import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Button} from 'reactstrap';
import {modal} from 'mc/lib';

/**
 * Tlačítko které při stisknutí zobrazí modální dialog s předaným obsahem.
 * Pokud není předán obsah dialogu, tlačítko bude skryté.
 */
class ButtonModalOutput extends PureComponent {

    static propTypes = {
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
    };

    showOutput = () => {
        const {value} = this.props;
        const modalProps = {size: 'lg'}
        this.props.dispatch(modal.ModalActions.show(() => <div className={"m-3"}>{value}</div>, null, null, modalProps));
    };

    render() {
        const {value} = this.props;
        return value ? <Button onClick={this.showOutput}>Zobrazit</Button> : null;
    }

}

export default connect()(ButtonModalOutput);
